import React from "react";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Hero from "components/hero/TwoColumnWithVideo.js";
import Features from "components/features/ThreeColSimple.js";
import MainFeature from "components/features/TwoColWithButton.js";
import MainFeature3 from "components/features/TwoColWithTwoHorizontalFeaturesAndButton.js";
import styled from "styled-components";
import Pricing from "components/pricing/ThreePlansWithHalfPrimaryBackground.js";
import Testimonial from "components/testimonials/ThreeColumnWithProfileImage.js";
import DownloadApp from "components/cta/DownloadApp.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import FAQ from "components/faqs/TwoColumnPrimaryBackground.js";
import ThreeColCenteredStatsWithPrimaryBackgroundFeatures from "components/features/ThreeColCenteredStatsPrimaryBackground.js";
import Apoiadores from "components/features/Apoiadores.js";

export default () => {
  const Subheading = tw.span`tracking-wider  text-primary-300 text-sm font-medium`;
  const HighlightedText = tw.span`bg-primary-100 text-gray-100 px-4 transform -skew-x-12 inline-block`;
  const HighlightedTextInverse = tw.span`bg-gray-100 text-primary-500 px-4 transform -skew-x-12 inline-block`;
  const Description = tw.span`inline-block mt-8`;
  const imageCss = tw`rounded-4xl`;
  
  // Componentes para a seção de Anamnese IA
  const AnamneseSection = styled.section`
    ${tw`py-20`}
    background: linear-gradient(135deg, rgba(99, 102, 241, 0.05) 0%, rgba(99, 102, 241, 0.1) 100%);
  `;
  
  const AnamneseContainer = tw.div`max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8`;
  
  const AnamneseContent = tw.div`lg:grid lg:grid-cols-2 lg:gap-16 lg:items-center`;
  
  const AnamneseTextContent = tw.div``;
  
  const AnamneseHeading = tw.h2`text-4xl font-extrabold text-gray-900 sm:text-5xl`;
  
  const AnamneseSubheading = tw.p`mt-4 text-xl text-gray-600`;
  
  const AnamneseFeatures = styled.div`
    ${tw`mt-8`}
    > * + * {
      margin-top: 1.5rem;
    }
  `;
  
  const AnamneseFeature = tw.div`flex items-start`;
  
  const AnamneseFeatureIcon = tw.div`flex-shrink-0 w-8 h-8 bg-primary-500 rounded-full flex items-center justify-center`;
  
  const AnamneseFeatureContent = tw.div`ml-4`;
  
  const AnamneseFeatureTitle = tw.h3`text-lg font-semibold text-gray-900`;
  
  const AnamneseFeatureDesc = tw.p`mt-1 text-gray-600`;
  
  const AnamneseImageContainer = tw.div`mt-12 lg:mt-0`;
  
  const AnamneseImage = tw.img`w-full rounded-2xl shadow-2xl`;
  
  const SecurityBadge = styled.div`
    ${tw`inline-flex items-center px-4 py-2 rounded-full text-sm font-medium mt-6`}
    background-color: rgba(16, 185, 129, 0.1);
    color: #047857;
  `;

  return (
    <AnimationRevealPage>
      <Hero
        heading={
          <>
            Conectamos profissionais de saúde{" "}
            <HighlightedText>com seus pacientes.</HighlightedText>
          </>
        }
        description="Somos a conexão da sua clínica com seu paciente através de recursos interativos para maior eficácia dos tratamentos."
        imageSrc="../doctorHappy.jpg"
        imageCss={imageCss}
        imageDecoratorBlob={true}
        primaryButtonText="Começar Agora"
        watchVideoButtonText="Ver Demo"
      />
      <MainFeature
        subheading={<Subheading>Por que nos escolher?</Subheading>}
        heading={
          <>
            Seu consultório na
            <wbr /> <HighlightedText>palma da mão</HighlightedText>
          </>
        }
        description={
          <Description>
            Gerenciamento de tempo com otimização de processos. Aproximamos você
            do seu paciente, com materiais didáticos interativos e ferramentas
            de fácil compreensão.
            <br />
            <br />
            Plataforma com linguagem simples, direcionada para pré e pós
            consulta em FONOAUDIOLOGIA E ODONTOLOGIA.
          </Description>
        }
        buttonRounded={false}
        textOnLeft={false}
        primaryButtonText="Ultimas Ofertas"
        primaryButtonUrl="https://www.trataz.com.br/register"
        imageSrc={"../tratamentImg.jpg"}
        imageCss={imageCss}
        imageDecoratorBlob={true}
        imageDecoratorBlobCss={tw`left-1/2 -translate-x-1/2 md:w-32 md:h-32 opacity-25`}
      />
      {/* TabGrid Component also accepts a tabs prop to customize the tabs and its content directly. Please open the TabGrid component file to see the structure of the tabs props.*/}
      <ThreeColCenteredStatsWithPrimaryBackgroundFeatures />
      <Features
        heading={
          <>
            Recursos <HighlightedText>Exclusivos</HighlightedText>
          </>
        }
        imageContainerCss={tw`p-2!`}
        imageCss={tw`w-20! h-20!`}
      />
      <Pricing />
      
      <AnamneseSection>
        <AnamneseContainer>
          <AnamneseContent>
            <AnamneseTextContent>
              <AnamneseHeading>
                Anamnese <HighlightedText>Inteligente</HighlightedText>
              </AnamneseHeading>
              <AnamneseSubheading>
                Nossa IA escuta suas consultas e gera relatórios personalizados automaticamente, 
                economizando tempo e garantindo precisão diagnóstica.
              </AnamneseSubheading>
              
              <AnamneseFeatures>
                <AnamneseFeature>
                  <AnamneseFeatureIcon>
                    <svg width="16" height="16" fill="white" viewBox="0 0 20 20">
                      <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </AnamneseFeatureIcon>
                  <AnamneseFeatureContent>
                    <AnamneseFeatureTitle>Transcrição Automática</AnamneseFeatureTitle>
                    <AnamneseFeatureDesc>
                      IA converte automaticamente suas conversas em texto estruturado e organizado.
                    </AnamneseFeatureDesc>
                  </AnamneseFeatureContent>
                </AnamneseFeature>
                
                <AnamneseFeature>
                  <AnamneseFeatureIcon>
                    <svg width="16" height="16" fill="white" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zm0 4a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zm8 0a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1h-6a1 1 0 01-1-1v-6z" clipRule="evenodd" />
                    </svg>
                  </AnamneseFeatureIcon>
                  <AnamneseFeatureContent>
                    <AnamneseFeatureTitle>Relatórios Personalizados</AnamneseFeatureTitle>
                    <AnamneseFeatureDesc>
                      Gera relatórios específicos para cada especialidade com dados relevantes destacados.
                    </AnamneseFeatureDesc>
                  </AnamneseFeatureContent>
                </AnamneseFeature>
                
                <AnamneseFeature>
                  <AnamneseFeatureIcon>
                    <svg width="16" height="16" fill="white" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M18 8a6 6 0 01-7.743 5.743L10 14l-1 1-1 1H6v2H2v-4l4.257-4.257A6 6 0 1118 8zm-6-4a1 1 0 100 2 2 2 0 012 2 1 1 0 102 0 4 4 0 00-4-4z" clipRule="evenodd" />
                    </svg>
                  </AnamneseFeatureIcon>
                  <AnamneseFeatureContent>
                    <AnamneseFeatureTitle>100% Seguro e Privado</AnamneseFeatureTitle>
                    <AnamneseFeatureDesc>
                      Dados criptografados e em conformidade total com a LGPD. Seus dados nunca saem do Brasil.
                    </AnamneseFeatureDesc>
                  </AnamneseFeatureContent>
                </AnamneseFeature>
              </AnamneseFeatures>
              
              <SecurityBadge>
                🔒 Certificado LGPD • Dados Criptografados
              </SecurityBadge>
            </AnamneseTextContent>
            
            <AnamneseImageContainer>
              <AnamneseImage 
                src="https://images.unsplash.com/photo-1551601651-2a8555f1a136?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" 
                alt="Profissional usando IA para anamnese"
                onError={(e) => {
                  e.target.src = "../doctorHappy.jpg";
                }}
              />
            </AnamneseImageContainer>
          </AnamneseContent>
        </AnamneseContainer>
      </AnamneseSection>
      
      <MainFeature3 />
      <Testimonial
        subheading=""
        heading={
          <>
            Profissionais <HighlightedText>Aprovam.</HighlightedText>
          </>
        }
        testimonials={[
          {
            imageSrc: "../edilaine_profissional.jpg",
            quote:
              "Com mais de 25 anos de experiência, Edilaine é uma fonoaudióloga apaixonada por transformar vidas através da comunicação, proporcionando um atendimento humanizado e resultados duradouros para seus pacientes.",
            customerName: "Edilaine Tannouri",
          },
          {
            imageSrc: "../carlos_antonio.jpg",
            quote:
              "Com ampla experiência e dedicação, Dr. Carlos é um dentista comprometido em oferecer sorrisos saudáveis e tratamentos de excelência, priorizando sempre o bem-estar e a confiança de seus pacientes.",
            customerName: "Antônio Carlos",
          },
          {
            imageSrc: "../pac2.png.jpg",
            quote:
              "Com mais de 20 anos de experiência acadêmica, o Professor Celso é um profissional dedicado ao ensino e à pesquisa, contribuindo significativamente para o desenvolvimento de novas metodologias e práticas na área da saúde.",
            customerName: "Professor Celso Santos Júnior",
          },
        ]}
      />
      <FAQ />

          <Testimonial
            subheading=""
            heading={
              <>
                Pacientes <HighlightedText>Satisfeitos.</HighlightedText>
              </>
            }
            testimonials={[
              {
                imageSrc: "../pac1.png",
                quote:
                "A Plataforma Trataz é muito bacana e prática de se utilizar, os vídeos gravados ajudam muito na realização do tratamento, os lembretes que chegam por email e principalmente WhatsApp contribuem muito para a disciplina de realizar os exercícios/terapia. Penso que essa ferramenta poderia ser explorada para muitas outras modalidades da área da saúde. 🙌🏻",
                customerName: "Eliane Lau",
              },
              {
                imageSrc: "../lorenzo.jpg",
                quote:
                "A plataforma revolucionou minha experiência como paciente. A interface intuitiva e os recursos interativos tornaram meu tratamento muito mais eficaz e fácil de seguir. Os lembretes e exercícios personalizados fazem toda a diferença no dia a dia.",
                customerName: "Lorenzo Thaz",
              },
              {
                imageSrc: "../pac3.png",
                quote:
                "Estou fazendo acompanhamento com a Dra. Edilaine depois da minha ortognática e vi uma diferença gigantesca desde a primeira sessão. A plataforma TRATAZ me ajudou demais a lembrar dos exercícios durante a semana. Foi super simples de achar e fazer os exercícios com ela. Cada dia estou melhor e com mais confiança, está sendo ótimo!.",
                customerName: "Ana Gabriela Menin Granado",
              },
              {
                imageSrc: "../pac4.png",
                quote:
                "A plataforma é muito boa pra mim que tive AVC e tenho um pouco de esquecimento. A fono passa os exercícios e quando chego em casa já esqueço, então a plataforma é um meio de poder ver os vídeos e lembrar como fazer os exercícios!.",
                customerName: "Islaine Marquardt",
              },
            ]}
          />
      <DownloadApp
        text={
          <>
            Pessoas ao seu redor estão otimizando seus tratamentos com a
            plataforma<HighlightedTextInverse>Trataz.</HighlightedTextInverse>
          </>
        }
      />
        <Apoiadores />
      <Footer />
    </AnimationRevealPage>
  );
};
